/*
  <rk-video> – stummes Loop-Video (snippets/rk-video.liquid)
  Spielt nur im Viewport, pausiert außerhalb. Kein Autoplay bei prefers-reduced-motion.
  Pausiert der Nutzer manuell, startet das Video nicht von selbst neu.
*/
if (!customElements.get('rk-video')) {
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  class RkVideo extends HTMLElement {
    connectedCallback() {
      this.video = this.querySelector('video');
      this.toggle = this.querySelector('.rk-video__toggle');
      if (!this.video) return;
      if (this.hasAttribute('data-controls')) {
        this.classList.remove('is-paused');
        return;
      }

      this.userPaused = reducedMotion.matches;
      this.inView = false;
      this.setPausedState(true);

      this.onToggle = () => {
        if (this.video.paused) {
          this.userPaused = false;
          this.play();
        } else {
          this.userPaused = true;
          this.video.pause();
        }
      };
      this.onPlay = () => this.setPausedState(false);
      this.onPause = () => this.setPausedState(true);

      this.toggle?.addEventListener('click', this.onToggle);
      this.video.addEventListener('click', this.onToggle);
      this.video.addEventListener('play', this.onPlay);
      this.video.addEventListener('pause', this.onPause);

      if (!('IntersectionObserver' in window)) {
        if (!this.userPaused) this.play();
        return;
      }

      this.observer = new IntersectionObserver(
        ([entry]) => {
          this.inView = entry.isIntersecting;
          if (this.inView) {
            if (!this.userPaused) this.play();
          } else if (!this.video.paused) {
            this.video.pause();
          }
        },
        { rootMargin: '100px 0px', threshold: 0.01 }
      );
      this.observer.observe(this);
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      this.toggle?.removeEventListener('click', this.onToggle);
      this.video?.removeEventListener('click', this.onToggle);
      this.video?.removeEventListener('play', this.onPlay);
      this.video?.removeEventListener('pause', this.onPause);
    }

    play() {
      if (this.video.readyState < 2) this.video.load();
      const promise = this.video.play();
      if (promise && typeof promise.catch === 'function') {
        promise.catch(() => this.setPausedState(true));
      }
    }

    setPausedState(paused) {
      this.classList.toggle('is-paused', paused);
      if (!this.toggle) return;
      const label = paused ? this.dataset.playLabel : this.dataset.pauseLabel;
      if (label) this.toggle.setAttribute('aria-label', label);
    }
  }

  customElements.define('rk-video', RkVideo);
}
